import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import uiDux from 'src/redux/ui';
import measureModeDux from 'src/redux/measureMode';
import constants from 'src/constants';
import utils from 'src/utils';
import MeasureNumber from './MeasureNumber';
import {
  CategoryContainer,
  CountBox,
  CountText,
  HeaderAndTotal,
  Header,
  Total,
  RightArrow,
} from './styled';

const { UNITS } = constants.measure;
const { isValidNestedNumber } = utils.measure;

export const mapStateToProps = (state) => ({
  activeCategoryName: measureModeDux.selectors.getActiveMeasurementCategory(
    state,
  ),
});

export const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      handleMeasurementCategoryClick:
        uiDux.actions.handleMeasurementCategoryClick,
    },
    dispatch,
  );

export class MeasureCategory extends PureComponent {
  static propTypes = {
    categoryName: PropTypes.string.isRequired,
    handleMeasurementCategoryClick: PropTypes.func.isRequired,
    total: PropTypes.object.isRequired,
    selected: PropTypes.bool.isRequired,
  };

  render() {
    const {
      categoryName,
      selected,
      total: { count, area, length },
      handleMeasurementCategoryClick,
    } = this.props;

    let totalNumber = 0;
    let isSquare = false;
    if (isValidNestedNumber(area, 'feet')) {
      totalNumber = area.feet;
      isSquare = true;
    } else if (isValidNestedNumber(length, 'feet')) {
      totalNumber = length.feet;
    }

    return (
      <CategoryContainer
        data-selenium="measureCategory"
        onClick={() => handleMeasurementCategoryClick(categoryName)}
        selected={selected}
        name={categoryName}
      >
        <CountBox>
          <CountText data-selenium="countText">{count}</CountText>
        </CountBox>
        <HeaderAndTotal>
          <Header data-selenium="categoryNameText">{categoryName}</Header>
          <Total>
            <MeasureNumber
              number={totalNumber}
              isSquare={isSquare}
              unit={UNITS.feet.abbreviation}
            />
          </Total>
        </HeaderAndTotal>
        {!selected && (
          <RightArrow src={require('src/assets/images/right-arrow.svg')} />
        )}
      </CategoryContainer>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(MeasureCategory);
